
    <template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 19">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M9.5 0C4.25379 0 0 4.25379 0 9.5C0 14.7462 4.25379 19 9.5 19C14.7462 19 19 14.7462 19 9.5C19 4.25379 14.7462 0 9.5 0ZM9.5 17.3884C5.14442 17.3884 1.61161 13.8556 1.61161 9.5C1.61161 5.14442 5.14442 1.61161 9.5 1.61161C13.8556 1.61161 17.3884 5.14442 17.3884 9.5C17.3884 13.8556 13.8556 17.3884 9.5 17.3884ZM10.1786 8.82143H13.4018C13.4951 8.82143 13.5714 8.89777 13.5714 8.99107V10.0089C13.5714 10.1022 13.4951 10.1786 13.4018 10.1786H10.1786V13.4018C10.1786 13.4951 10.1022 13.5714 10.0089 13.5714H8.99107C8.89777 13.5714 8.82143 13.4951 8.82143 13.4018V10.1786H5.59821C5.50491 10.1786 5.42857 10.1022 5.42857 10.0089V8.99107C5.42857 8.89777 5.50491 8.82143 5.59821 8.82143H8.82143V5.59821C8.82143 5.50491 8.89777 5.42857 8.99107 5.42857H10.0089C10.1022 5.42857 10.1786 5.50491 10.1786 5.59821V8.82143Z"
    fill="currentColor"
  ></path>
</svg>

    </template>

    <script lang="ts">
    import type { DefineComponent } from 'vue'
    export default ({
      name: 'PlusCircle',
    }) as DefineComponent
    </script>
    